import { getFeatureFlags } from '~/App/config/featureFlags';

export const featureIsEnabled = (feature) => {
  return getFeatureFlags()[feature];
};
